import {
  Component,
  ElementRef,
  EventEmitter,
  Output,
  Renderer2,
  ViewChild,
} from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators,
} from '@angular/forms';
import { NotifierService } from 'angular-notifier';
import Validation from '../../validation/confirm-password-validation';
import { VerifyService } from './service/verify.service';
import * as CryptoJS from 'crypto-js';
import { Router } from '@angular/router';
import { LoginService } from '../login/service/login.service';
@Component({
  selector: 'app-verify',
  templateUrl: './verify.component.html',
  styleUrl: './verify.component.scss',
})
export class VerifyComponent {
  showBtn = false;
  emitVal = false;
  loginForm!: FormGroup;
  localValue: any;
  getEmailVerifyResponseData: any;
  permitedEmail: any;
  type: string = 'password';
  isText = false;
  eyeIcon = 'fa-eye-slash';
  passwordIcon = 'fa fa-lock';
  showC = false;
  sign = true;
  tokens: any;
  spinner = false;
  showVerifyForm = 'verify';
  otpInput: any;
  submitted = false;
  loginSubmitted = false;
  passwordForm: FormGroup = new FormGroup({});
  receiveSgnVfy: any;
  submittedPassword: boolean = false;
  password_reset: boolean = false;

  // ── CAPTCHA ──────────────────────────
  captchaText: string = '';
  captchaInput: string = '';
  captchaVerified: boolean = false;
  captchaSubmitted: boolean = false;
  // ─────────────────────────────────────

  private readonly notifier: NotifierService;
  postData = {
    email: '',
    encrypted_data: '',
    pass_phrase: "6389U%$B*P*-'TD5",
    salt: "`W/Q`,1/N.CG'%3I",
  };

  @ViewChild('verifyOTP') verifyOTP!: ElementRef;
  @ViewChild('verifyOTPError') verifyOTPError!: ElementRef;
  @ViewChild('verifyOTPBtn') verifyOTPBtn!: ElementRef;
  @Output() formChange: EventEmitter<any> = new EventEmitter();
  constructor(
    private notifierService: NotifierService,
    private router: Router,
    private formBuilder: FormBuilder,
    private verifyService: VerifyService,
    private service: LoginService,
    private renderer: Renderer2,
  ) {
    this.notifier = notifierService;
  }

  ngOnInit(): void {
    this.passwordForm = this.formBuilder.group(
      {
        password: [
          '',
          [
            Validators.required,
            Validators.minLength(8),
            Validators.maxLength(40),
            Validators.pattern(
              '(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-zd$@$!%*?&].{8,}',
            ),
          ],
        ],
        confirmPassword: ['', Validators.required],
      },
      {
        validators: [Validation.match('password', 'confirmPassword')],
      },
    );
    this.generateCaptcha();
  }

  get f(): { [key: string]: AbstractControl } {
    return this.passwordForm.controls;
  }

  hideShowPassword() {
    this.isText = !this.isText;
    this.isText ? (this.eyeIcon = 'fa-eye') : (this.eyeIcon = 'fa-eye-slash');
    this.isText ? (this.type = 'text') : (this.type = 'password');
  }

  makeRandom(lengthOfCode: number, possible: string) {
    let text = '';
    for (let i = 0; i < lengthOfCode; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
  }

  goBack() {
    //this.loginForm.reset();
    this.showBtn = false;
    this.formChange.emit('login');
  }

  // submitOtp() {
  //   this.spinner = true;
  //   const otpPayload = {
  //     is2fa: false,
  //     verifyotp: this.otpInput?.toString().trim(),
  //   };
  //   this.verifyService.postOtp(otpPayload).subscribe({
  //     next: (response: any) => {
  //       if (this.showVerifyForm === 'verify') {
  //        // this.service.getFreePlan().subscribe();
  //       //  this.showComp.emit({make: true, name: 'signUp'});
  //      sessionStorage.setItem('token',response['token']);
  //      this.verifyService.verifyToken = response['token'];
  //      this.password_reset = response.password_reset;
  //      if(!response.password_reset){
  //         this.showVerifyForm = 'otp';
  //      }else{
  //         //localStorage.setItem('token', response['token']);
  //                   this.service.getUser().subscribe((response:any)=>{
  //                       var data = CryptoJS.AES.encrypt(JSON.stringify(response),this.service.enCryptKey);
  //                       localStorage.setItem("user",data.toString());
  //                        this.service.isAuthorizedUser=true;
  //                       // this.showComp.emit({ make: true, name: 'login' });
  //                         this.router.navigateByUrl("dashboard");
  //                        this.spinner = false;
  //                   });
  //      }

  //       }
  //       this.spinner = false;
  //     },
  //     error: (err: any) => {
  //       console.log('otp error', err);
  //       this.spinner = false;
  //       // this.notifier.notify('error', 'The PIN you entered is incorrect.');
  //     },
  //   });
  // }

  submitOtp() {
    // ── CAPTCHA GUARD ────────────────────
    this.captchaSubmitted = true;
    if (!this.captchaVerified) return;
    // ─────────────────────────────────────

    this.spinner = true;
    const otpPayload = {
      is2fa: false,
      verifyotp: this.otpInput?.toString().trim(),
    };
    this.verifyService.postOtp(otpPayload).subscribe({
      next: (response: any) => {
        if (this.showVerifyForm === 'verify') {
          sessionStorage.setItem('token', response['token']);
          this.verifyService.verifyToken = response['token'];
          this.password_reset = response.password_reset;
          if (!response.password_reset) {
            this.showVerifyForm = 'otp';
          } else {
            this.service.getUser().subscribe((response: any) => {
              var data = CryptoJS.AES.encrypt(
                JSON.stringify(response),
                this.service.enCryptKey,
              );
              localStorage.setItem('user', data.toString());
              this.service.isAuthorizedUser = true;
              this.router.navigateByUrl('dashboard');
              this.spinner = false;
            });
          }
        }
        this.spinner = false;
      },
      error: (err: any) => {
        this.spinner = false;
        // regenerate on wrong OTP so captcha can't be reused ──
        this.generateCaptcha();
      },
    });
  }

  onSubmit(): void {
    this.submitted = true;
    if (this.passwordForm.invalid) {
      return;
    }
    const values = this.passwordForm.value;
    const email = localStorage.getItem('loginuser');
    const password = values.password;
    const possible =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890,./;'[]=-)(*&^%$#@!~`";
    const dynamic_str = this.makeRandom(16, possible);
    const salt = this.makeRandom(16, possible);
    const iterations = 128;
    const bytes = CryptoJS.PBKDF2(dynamic_str, salt, {
      keySize: 48,
      iterations: iterations,
    });
    const iv = CryptoJS.enc.Hex.parse(bytes.toString().slice(0, 32));
    const key = CryptoJS.enc.Hex.parse(bytes.toString().slice(32, 96));

    const ciphertext = CryptoJS.AES.encrypt(password, key, { iv: iv });
    const formEncript = {
      email: email?.trim(),
      encrypted_data: ciphertext.toString(),
      salt: salt,
      pass_phrase: dynamic_str,
    };

    this.spinner = true;
    this.verifyService.postPassword(formEncript).subscribe({
      next: (response: any) => {
        this.showVerifyForm = 'passwordSuccess';
        this.verifyService.verifyToken = '';
        this.spinner = false;
        this.submitted = false;
        this.isText = false;
      },
      error: (err: any) => {
        this.spinner = false;
      },
    });
  }

  ngAfterViewInit() {
    this.renderer.setStyle(
      this.verifyOTPError.nativeElement,
      'display',
      'none',
    );
    this.renderer.setAttribute(
      this.verifyOTPBtn.nativeElement,
      'disabled',
      'true',
    );
    this.renderer.listen(
      this.verifyOTP.nativeElement,
      'input',
      (event: any) => {
        let pattern = /^[0-9]\d*$/;
        let inputvalue: any = event.target.value;
        if (!pattern.test(inputvalue)) {
          this.renderer.setStyle(
            this.verifyOTPError.nativeElement,
            'display',
            'block',
          );
          this.renderer.setAttribute(
            this.verifyOTPBtn.nativeElement,
            'disabled',
            'true',
          );
          setTimeout(() => {
            this.verifyOTP.nativeElement.value = '';
          }, 1500);
        } else {
          this.renderer.setStyle(
            this.verifyOTPError.nativeElement,
            'display',
            'none',
          );
          this.renderer.removeAttribute(
            this.verifyOTPBtn.nativeElement,
            'disabled',
          );
        }
      },
    );
  }

  generateCaptcha(): void {
    const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghjkmnpqrstuvwxyz23456789';
    this.captchaText = Array.from(
      { length: 6 },
      () => chars[Math.floor(Math.random() * chars.length)],
    ).join('');
    this.captchaVerified = false;
    this.captchaInput = '';
    this.captchaSubmitted = false;

    requestAnimationFrame(() => {
      requestAnimationFrame(() => this.drawCaptcha());
    });
  }

  drawCaptcha(): void {
    const canvas = document.getElementById(
      'captchaCanvas',
    ) as HTMLCanvasElement;
    if (!canvas) return;
    const ctx = canvas.getContext('2d')!;
    canvas.width = 180;
    canvas.height = 44;

    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, 180, 44);

    for (let i = 0; i < 4; i++) {
      ctx.beginPath();
      ctx.moveTo(Math.random() * 180, Math.random() * 44);
      ctx.lineTo(Math.random() * 180, Math.random() * 44);
      ctx.strokeStyle = `hsla(${Math.random() * 360}, 30%, 75%, 0.5)`;
      ctx.lineWidth = 1;
      ctx.stroke();
    }

    const colors = [
      '#1a56db',
      '#0f6e56',
      '#993c1d',
      '#534ab7',
      '#72243e',
      '#3b6d11',
    ];
    this.captchaText.split('').forEach((ch, i) => {
      ctx.save();
      const x = 18 + i * 26;
      const y = 28 + (Math.random() * 6 - 3);
      ctx.translate(x, y);
      ctx.rotate((Math.random() - 0.5) * 0.35);
      ctx.font = `600 22px system-ui, -apple-system, sans-serif`;
      ctx.fillStyle = colors[i % colors.length];
      ctx.fillText(ch, 0, 0);
      ctx.restore();
    });

    for (let i = 0; i < 25; i++) {
      ctx.beginPath();
      ctx.arc(Math.random() * 180, Math.random() * 44, 0.8, 0, 2 * Math.PI);
      ctx.fillStyle = 'rgba(0,0,0,0.06)';
      ctx.fill();
    }
  }

  verifyCaptcha(): void {
    this.captchaVerified = this.captchaInput.trim() === this.captchaText;
  }
}
